<template>
    <v-dialog-old ref="dialog" id="medflexClinic" :overflow="true">
        <fieldset disabled>
            <legend>Клиника МЕДФЛЕКС</legend>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Shop id</span>
                <input :value="medflexClinic.shop_id" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Название</span>
                <input :value="medflexClinic.clinic_name" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Адрес</span>
                <input :value="medflexClinic.address" readonly/>
            </span>
        </fieldset>

        <fieldset style="overflow: visible;">
            <legend>Клиника ДОКТУ</legend>
            <div v-if="medflexClinic.clinic"
                 class="textarea"
                 style="position: relative; background-color: #f8f8f8 !important;">
                <span>{{ medflexClinic.clinic.name }}</span>
                <br>
                <small>{{ medflexClinic.clinic.cityName }}, {{ medflexClinic.clinic.address }}</small>
                <button v-if="!medflexClinic.good_match" class="tiny redHover" @click.prevent="medflexClinic.clinic = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
            <v-select v-else-if="!selectedClinic"
                      v-on:remove="selectClinic"
                      :options="foundClinics"
                      @search-change="findClinics"
                      placeholder="Поиск клиник...">
                <template v-slot="{ option }">
                    <div class="textarea" >
                        <span>{{ option.text }}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="option.networkName !== null" class="label bg-red">
                            {{ option.networkName }}
                        </span>
                        <br>
                        <small>{{ option.cityName }}, {{ option.address }}</small>
                    </div>
                </template>
            </v-select>
            <div v-else class="textarea" style="position: relative;">
                <span>{{ selectedClinic.name }}</span><br />
                <small>{{ selectedClinic.cityName }}, {{ selectedClinic.address }}</small>
                <button class="tiny redHover" @click.prevent="selectedClinic = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
        </fieldset>

        <v-table id="medflexClinicTable"
                 :request-uri="'medflex/' + medflexClinic.id + '/getLines'"
                 pagesize="25"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="category" width="280">
                        Категория
                    </v-th>
                    <v-th name="name" sort="name" minwidth="400">
                        Название
                    </v-th>
                    <v-th name="price" sort="price" width="120">
                        Цена
                    </v-th>
                    <v-th name="tags" width="450">
                        Теги
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover" :id="'pl-tr-' + item.id">
                    <v-td name="category">
                        {{ item.category }}
                    </v-td>
                    <v-td name="name">
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td name="price" align="right">
                        <span>{{ item.price }}</span>
                    </v-td>
                    <v-td name="tags">
                        <template v-for="service in item.tags">
                            <template v-if="['ACCEPTED', 'ACCEPTED_MANUAL', 'NEW'].indexOf(service.status) !== -1">
                                <nobr>
                                    <span :class="service.status">{{ service.name }}</span>
                                </nobr>
                                <br/>
                            </template>
                        </template>
                    </v-td>
                </v-tr>
            </template>
        </v-table>

        <template v-slot:footer>
            <v-loading-component @click="save">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: !medflexClinic.clinic && selectedClinic}, loadingClass]"
                            :disabled="medflexClinic.clinic || !selectedClinic">
                        Сохранить
                    </button>
                </template>
            </v-loading-component>

            <button style="top: 0" @click="exportPricelist">
                <img width="25" src="data:image/svg+xml;base64,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">
                Экспорт
            </button>
        </template>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            medflexClinic: {
                id: null,
                clinic_name: null,
                good_match: false,
                address: null,
                shop_id: null,
                pricelist_status: null,
                created_at: null,
                updated_at: null,
                clinic: null,
                pricelist_id: null,
            },
            foundClinics: [],
            selectedClinic: null,
            clinicSearchRequest: null,
        };
    },
    methods: {
        resetData() {
            this.medflexClinic = {
                id: null,
                clinic_name: null,
                address: null,
                shop_id: null,
                good_match: false,
                pricelist_status: null,
                created_at: null,
                updated_at: null,
                clinic: null,
                pricelist_id: null,
            };
            this.foundClinics = [];
            this.selectedClinic = null;
            this.clinicSearchRequest = null;
            this.originalClinicId = null;
        },
        show(id) {
            this.resetData();

            return this.axios.get('medflex/' + id + '/read').then(response => {
                Object.assign(this.medflexClinic, response.data);
                this.originalClinicId = response.data.clinic?.id;
                this.$refs.dialog.show();
            });
        },
        save(btn) {
            if (this.medflexClinic.clinic || !this.selectedClinic) {
                return;
            }

            btn.startLoadingAnimation();

            this.axios.post('medflex/' + this.medflexClinic.id + '/save', {
                clinic_id: this.selectedClinic.id,
            }).then(response => {
                btn.stopLoadingAnimation();
                this.$emit('updated');
                this.$bus.fire('updateMenu');
                this.$refs.dialog.hide();
            }).catch(response => {
                if (response.status === 'error') {
                    this.$modal('Выбранная клиника уже имеет другую связь с Медфлексом', {
                        name: 'ОК',
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, {
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, false, 'only-text-dialog');
                }
            });
        },
        exportPricelist() {
            window.open('doctu/' + this.medflexClinic.pricelist_id + '/export');
        },
        findClinics(query) {
            if (this.clinicSearchRequest) {
                this.clinicSearchRequest.cancel();
            }

            if (query.length > 2) {
                this.clinicSearchRequest = this.axios.CancelToken.source();

                this.axios.post('/clinicsAutocomplete', {
                    q: query,
                    filter: {
                        without_published_medflex: true,
                    }
                }, {
                    cancelToken: this.clinicSearchRequest.token
                }).then(res => {
                    this.foundClinics = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.name,
                            cityName: item.data.cityName,
                            networkName: item.data.networkName,
                            address: item.data.address,
                            children: item.data.children,
                        }
                    })
                }).catch(() => {})
            } else {
                this.foundClinics = [];
            }
        },
        selectClinic(payload) {
            this.selectedClinic = {
                id: payload.id,
                name: payload.text,
                cityName: payload.cityName,
                address: payload.address
            };

            this.foundClinics = [];
        },
    },
}
</script>

<style scoped>
#medflexClinicTable {
    height: 50vh;
    margin-top: 10px;
}
</style>
